import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import IndexedDBManager from '../utils/IndexedDBManager';

const initialState = {
  manager: null,
  status: 'undefined',
  files: []
};

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...initialState,
        manager: action.payload,
        files: action.files,
        status: 'init'
      };
    case 'unsupported':
      return {
        ...initialState,
        status: 'unsupported'
      };
    case 'updated':
      return { ...state, files: action.files };
    default:
      throw new Error('Unkown Acion For IndexedDBContext');
  }
}

async function updateFileList({ state, dispatch }) {
  const files = await state.manager.getFiles();
  dispatch({ type: 'updated', files });
}

export async function saveFile({ state, dispatch, file, isNaverWorksFile, naverWorksFileInfo }) {
  if (state.status !== 'init') {
    return;
  }
  const copyFile = new File([file], file.name);
  await state.manager.saveFile(copyFile, isNaverWorksFile, naverWorksFileInfo);
  await updateFileList({ state, dispatch });
}

export async function removeFile({ state, dispatch, file }) {
  if (state.status !== 'init') {
    return;
  }
  await state.manager.removeFile(file);
  await updateFileList({ state, dispatch });
}

export async function removeTempfiles({ state, dispatch, files }) {
  if (state.status !== 'init') {
    return;
  }

  const tmpfiles = files.filter((file) => {
    return file.file.name.endsWith('.tmp');
  });
  for (let i = 0; i < tmpfiles.length; i++) {
    const file = tmpfiles[i];
    await state.manager.removeFile(file.file);
  }
  updateFileList({ state, dispatch });
}

export async function initIndexedDB(state, dispatch) {
  if (state.status === 'undefined') {
    const manager = new IndexedDBManager();
    const avail = await manager.available();
    if (avail === true) {
      await manager.open();
      const files = await manager.getFiles();
      dispatch({ type: 'init', payload: manager, files: files });
      return files;
    } else {
      dispatch({ type: 'unsupported' });
    }
  }
  return null;
}

const IndexedDBState = createContext(null);
const IndexedDBDispatch = createContext(null);

export function IndexedDBContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [initDB, setInitDB] = useState(false);

  useEffect(() => {
    if (initDB === false) {
      initIndexedDB(state, dispatch).then(() => {
        setInitDB(true);
      });
    }
  }, [state, initDB]);

  return (
    <IndexedDBState.Provider value={state}>
      <IndexedDBDispatch.Provider value={dispatch}>{initDB && children}</IndexedDBDispatch.Provider>
    </IndexedDBState.Provider>
  );
}

export function useIndexedDBState() {
  const state = useContext(IndexedDBState);
  if (!state) throw new Error('cannot find useIndexedDBState');

  return state;
}

export function useIndexedDBDispatch() {
  const dispatch = useContext(IndexedDBDispatch);
  if (!dispatch) throw new Error('cannot find useIndexedDBDispatch');

  return dispatch;
}
